export default {
	namespaced: true,

	state: {
		isInitialized: false,
		isMobileScreen: false,
		isDarkTheme: false,

		createdDatetime: null,

		screenWidth: null,
		screenHeight: null,

		language: null,
		menuGroup: null,
		theme: null,

		firebase: {
			firestore: {
				read: 0,
				write: 0
			},
			functions: {
				call: 0
			}
		},

		oneSignal: {
			userId: null
		},

		pwa: {
			deferredPrompt: null,
			prompted: false
		}
	},

	getters: {
		get: state => state
	},

	mutations: {
		setValue (state, [key, value]) {
			state[key] = value;
		},
		setSubValue (state, [key, subKey, value]) {
			state[key][subKey] = value;
		}
	},

	actions: {
	}
}
